
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 7.813c.88 0 1.71.101 2.488.304.779.17 1.473.39 2.082.66.61.271 1.084.677 1.422 1.22.339.54.508 1.116.508 1.726V13.5h-13v-1.727c0-.643.17-1.235.508-1.777A3.132 3.132 0 018.43 8.777c.61-.27 1.303-.49 2.082-.66A9.826 9.826 0 0113 7.812zm-8.684.253c.61 0 1.118-.203 1.524-.609.44-.44.66-.948.66-1.523 0-.61-.22-1.118-.66-1.524a1.987 1.987 0 00-1.524-.66c-.575 0-1.083.22-1.523.66-.406.406-.61.914-.61 1.524 0 .575.204 1.083.61 1.523.44.406.948.61 1.523.61zm1.22 1.22a2.853 2.853 0 00-.56-.052 4.021 4.021 0 00-.66-.05c-.541 0-1.066.05-1.574.152a7.706 7.706 0 00-1.422.457c-.406.17-.728.44-.965.813A2.226 2.226 0 000 11.823V13.5h4.875v-1.727c0-.88.22-1.71.66-2.488zm16.148-1.22c.575 0 1.066-.203 1.472-.609.44-.44.66-.948.66-1.523 0-.61-.22-1.118-.66-1.524-.406-.44-.897-.66-1.472-.66-.61 0-1.135.22-1.575.66-.406.406-.609.914-.609 1.524 0 .575.203 1.083.61 1.523.44.406.964.61 1.574.61zM26 11.824c0-.44-.119-.846-.355-1.219a2.055 2.055 0 00-.965-.812 7.426 7.426 0 00-1.473-.457 7.262 7.262 0 00-1.523-.152c-.237 0-.457.017-.66.05-.204 0-.39.017-.56.051.44.779.661 1.608.661 2.488V13.5H26v-1.676zM13 .5c.61 0 1.151.152 1.625.457.508.27.897.66 1.168 1.168.305.474.457 1.016.457 1.625 0 .61-.152 1.168-.457 1.676-.27.474-.66.863-1.168 1.168C14.151 6.864 13.609 7 13 7c-.61 0-1.168-.135-1.676-.406a3.845 3.845 0 01-1.168-1.168A3.505 3.505 0 019.75 3.75c0-.61.135-1.151.406-1.625A3.219 3.219 0 0111.324.957 3.196 3.196 0 0113 .5z"}})])
          )
        }
      }
    